export const MODAL_TYPE_FILTER_AND_SORT = 'filter-and-sort';
